import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation, useNavigate } from "react-router-dom";

import HeroSection from "./HomePage/HeroSection";
import FitCheckSection from "./HomePage/FitCheckSection";
import HowThisWorksSection from "./HomePage/HowThisWorksSection";
import AboutSection from "./HomePage/AboutSection";
import WhySection from "./HomePage/WhySection";
import CaseStudies from "./HomePage/CaseStudies";
//import InsightSection from "./HomePage/InsightSection";
import CTASection from "./HomePage/CTASection";
import Contact from "./HomePage/Contact";
import LearningHeroSection from "./HomePage/LearningHeroSection";
import ContactModalDrawer from "./HomePage/ContactModalDrawer";
import WhatFoundersSaySection from "./HomePage/WhatFoundersSaySection";

import AOS from "aos";
import "aos/dist/aos.css";

import Header from "../Header";
import Footer from "../Footer";

const Home = () => {
    const [isContactOpen, setIsContactOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    useEffect(() => {
        if (location.hash === "#start-a-conversation") {
            setIsContactOpen(true);
        }
    }, [location.hash]);

    const handleCloseContact = () => {
        setIsContactOpen(false);
        if (location.hash === "#start-a-conversation") {
            navigate(location.pathname, { replace: true });
        }
    };

    return (
        <main>
            <Helmet>
                <title>Buzz To Brand | Fix the Growth Problem You Already Have</title>

                <meta
                    name="description"
                    content="Referral abuse, retention gaps, or your next category launch. I help D2C founders solve it using data they already have. Start a conversation."
                />

                <link
                    rel="canonical"
                    href="https://buzztobrand.com/"
                />
            </Helmet>

            <Header />
            <HeroSection onPrimaryClick={() => setIsContactOpen(true)} />
            <WhatFoundersSaySection />
            <HowThisWorksSection />
            {/* <CaseStudies activeTag="all" /> */}
            <AboutSection />
            <CTASection onCtaClick={() => setIsContactOpen(true)} />
            <Contact />
            <Footer />
            
            <ContactModalDrawer isOpen={isContactOpen} onClose={handleCloseContact} />
        </main>
    );
};

export default Home;
